import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RelatedPartyTypeEqualsTo,
  RulesetResult,
  PrincipalOwns,
  IsApplicantSameAsPrincipal,
} from '../rules/';

import { RELATED_PARTY_TYPES } from '../../../../../../../constants';

class PrincipalMortgagePaymentRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPrincipal = RelatedPartyTypeEqualsTo.setType(
      RELATED_PARTY_TYPES.INDIVIDUAL
    )
      .setPrincipalId(this.principalId)
      .evaluate(data);
    const principalOwns = PrincipalOwns.setPrincipalId(
      this.principalId
    ).evaluate(data);

    const applicantSameAsPrincipal = IsApplicantSameAsPrincipal.setPrincipalId(
      this.principalId
    );
    const isApplicantSameAsPrincipal = applicantSameAsPrincipal.evaluate(data);

    if (isPrincipal && isApplicantSameAsPrincipal && principalOwns) {
      return RulesetResult.REQUIRED;
    }

    return RulesetResult.HIDDEN;
  };
}

export default new PrincipalMortgagePaymentRuleset();
